'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _supportedPhoneNumbersRegexp = require('./supportedPhoneNumbersRegexp');

var _supportedPhoneNumbersRegexp2 = _interopRequireDefault(_supportedPhoneNumbersRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (text, prefix) {
    return text.replace(_supportedPhoneNumbersRegexp2.default, function (substring) {
        var link = '[' + substring.trim() + '](' + prefix + substring.trim() + ')';
        var spacesBeforeLink = substring.match(/^\s*/)[0];
        var spacesAfterLink = substring.match(/\s*$/)[0];
        return '' + spacesBeforeLink + link + spacesAfterLink;
    });
};